/* istanbul ignore file */
// ignore test because there is no logic

import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '@/modules/reducers';
import rootServices from '@/modules/services';

const middlewares = [rootServices.middleware];

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(middlewares),
});

export default store;
